import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as Close } from "../../../../assets/images/teamclose.svg";
import { ReactComponent as ChatTag } from "../../../../assets/images/TicketImages/tag.svg";
import { CircularProgress, Box } from "@mui/material";
import SearchInput from "../../../common/SearchInputField";
import NoSearch from "../../../common/NoSearch";
import { fetchTags } from "../../../../store/features/tagsApi";

function KbTagPopup({ onClose, onApply, selectedTags = [] }) {
    const dispatch = useDispatch();
    const businessId = useSelector((state) => state.loginToken?.response?.user?.business_id);
    const { list: availableTags = [], loading } = useSelector((state) => state.tags);

    const [searchQuery, setSearchQuery] = useState("");
    const [filteredTags, setFilteredTags] = useState([]);
    const [selectedTagList, setSelectedTagList] = useState(selectedTags);

    useEffect(() => {
        setSelectedTagList(selectedTags);
    }, [selectedTags]);

    useEffect(() => {
        if (businessId) {
            dispatch(fetchTags({ businessId, type: "knowledge_base" }));
        }
    }, [dispatch, businessId]);

    useEffect(() => {
        if (searchQuery) {
            setFilteredTags(
                availableTags.filter((tag) =>
                    tag.name.toLowerCase().includes(searchQuery.toLowerCase())
                )
            );
        } else {
            setFilteredTags(availableTags);
        }
    }, [availableTags, searchQuery]);

    const handleSearchInputChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const handleTagClick = (tag) => {
        setSelectedTagList((prevSelected) => {
            const isSelected = prevSelected.some(t => (t._id || t.id) === (tag._id || tag.id));
            if (isSelected) {
                return prevSelected.filter((t) => (t._id || t.id) !== (tag._id || tag.id));
            }
            return [...prevSelected, tag];
        });
    };

    const handleApply = () => {
        if (onApply) {
            onApply(selectedTagList);
        }
        onClose();
    };

    return (
        <>
            <div className="overlay" style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 1200 }} onClick={onClose} />
            <div className="Assign-PopUp-Container" style={{ zIndex: 1201 }}>
                <div className="Team-PopUp-Header">
                    <p className="PopUp-Text01">Add Tag</p>
                    <p className="PopUp-Text02" onClick={onClose} style={{ cursor: 'pointer' }}>
                        <Close />
                    </p>
                </div>

                <div className="SearchChat-Popup">
                    <SearchInput
                        title=""
                        placeholder="Search tags"
                        value={searchQuery}
                        onChange={handleSearchInputChange}
                    />
                </div>

                {loading ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            minHeight: "200px",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                ) : (
                    <div
                        className="AgentsList"
                        style={{
                            maxHeight: "200px", overflowY: "auto", padding: '0px'
                        }}>
                        {
                            filteredTags.length === 0 ? (
                                <NoSearch
                                    title="No tags found"
                                    description="Try searching with different keywords."
                                />
                            ) : (
                                filteredTags.map((tag) => (
                                    <div style={{ padding: '8px 16px' }}
                                        className={`ChatPopup-Darleen-Container`}
                                        key={tag._id || tag.id}
                                        onClick={() => handleTagClick(tag)}
                                    >

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "24px",
                                                height: "24px",
                                                "& svg path": {
                                                    stroke: selectedTagList.some(t => (t._id || t.id) === (tag._id || tag.id)) ? "#148DFD" : "#556575",
                                                },
                                            }}
                                        >
                                            <ChatTag />
                                        </Box>

                                        <div>
                                            <p
                                                style={{
                                                    color: selectedTagList.some(t => (t._id || t.id) === (tag._id || tag.id)) ? "#061522" : "#556575",
                                                    fontSize: "14px",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    marginTop: '1px'
                                                }}
                                            >
                                                {tag.name}
                                            </p>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                    </div>
                )}

                <hr
                    style={{
                        backgroundColor: "#F1F3F5",
                        height: "1px",
                        border: "none",
                        margin: "16px 0",
                    }}
                />

                <div style={{ display: "flex", width: "100%", gap: "8px" }}>
                    <button
                        className="cancel-btn"
                        onClick={onClose}
                        style={{
                            background: "transparent",
                            padding: "8px 16px",
                            borderRadius: "8px",
                            cursor: "pointer",
                            width: "100%",
                            border: "1px solid #D5DCE1"
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        className="AddTansfer"
                        onClick={handleApply}
                        style={{
                            width: "100%",
                            padding: "8px 16px",
                            background: "#148DFD",
                            color: "#FFF",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer"
                        }}
                    >
                        Apply
                    </button>
                </div>
            </div >
        </>
    );
}

export default KbTagPopup;
